import { sidebarConfig, useSidebarOpenState } from '@backstage/core-components';
import { Box, Flex, Text } from '@backstage/ui';
import { Link } from 'react-router-dom';

export const CustomSidebarLogo = () => {
  const { isOpen } = useSidebarOpenState();
  const logoWidth = isOpen ? 66 : 44;
  const logoHeight = isOpen ? 50 : 35;
  const sidebarWidth = isOpen
    ? sidebarConfig.drawerWidthOpen
    : sidebarConfig.drawerWidthClosed;

  return (
    <Box
      data-theme-mode="dark"
      width={`${sidebarWidth}px`}
      height={`${3 * sidebarConfig.logoHeight}px`}
      display="flex"
    >
      <Link to="/" aria-label="Home">
        <Flex align="center" gap={isOpen ? '4' : '2'} ml={isOpen ? '8' : '2'}>
          <img
            src="/obos_liggende_hus_rgb.png"
            alt="Logo"
            width={logoWidth}
            height={logoHeight}
          />
          {isOpen && (
            <Text variant="body-large" weight="bold">
              Blueprint
            </Text>
          )}
        </Flex>
      </Link>
    </Box>
  );
};
